module.exports = "mutation sendAGBs($sendAGBsInput:SendAGBsInput!){sendAGBs(sendAGBsInput:$sendAGBsInput)}"